"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanize = exports.capitalizeSnakeCase = exports.capitalize = void 0;
var humps_1 = require("humps");
/**
 * Capitalizes the first charactaer of a string.
 * @param s The string to capitalize.
 */
var capitalize = function (s) {
    if (typeof s !== 'string')
        return '';
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};
exports.capitalize = capitalize;
/**
 * Converts a snake cased string into an appended list of capitalized words.
 * @param s The string to capitalize.
 */
var capitalizeSnakeCase = function (s) {
    return s.split('_').map(exports.capitalize).join(' ');
};
exports.capitalizeSnakeCase = capitalizeSnakeCase;
/**
 * A utility method to make a programattic string human readable.
 * @param str The string to format.
 */
var humanize = function (str, camelized) {
    return (0, exports.capitalizeSnakeCase)(camelized ? (0, humps_1.decamelize)(str) : str);
};
exports.humanize = humanize;
